module.exports = __webpack_public_path__ + "static/img/1046_big.e0ce362.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1046_big.png
// module id = O+2S
// module chunks = 1